import React from "react";
import { Field } from "react-final-form";
import { TextField } from "@mui/material";
import RffInputWrapper from "../shared/RffInputWrapper";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const RffEmailField = ({
  name,
  label,
  required = false,
  helperText,
  placeholder,
  fullWidth = true,
  row = false,
  suppressGrid,
  size,
  disabled,
}) => (
  <RffInputWrapper
    label={label}
    suppressGrid={suppressGrid}
    size={size}
    helperText={helperText}
    required={required}
    row={row}
  >
    <Field
      name={name}
      validate={(v) => {
        if (required && (v == null || v === "")) return "This field is required";
        if (v && !EMAIL_RE.test(String(v))) return "Enter a valid email";
        return undefined;
      }}
      parse={(v) => (v === "" ? undefined : v)}
      render={({ input, meta }) => (
        <TextField
          {...input}
          type="email"
          placeholder={placeholder}
          disabled={disabled}
          fullWidth={fullWidth}
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : null}
        />
      )}
    />
  </RffInputWrapper>
);

export default RffEmailField;
